module.exports = "https://coursera_assets.s3.amazonaws.com/images/b5ce4782d82fffeab347c173e718d133.png";